/* Usability session tooling (W3-05): the status bar chip and the #/dev/usability task sheet. Tokens only. */

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  padding: 0 var(--space-2);
  border: var(--border-width) solid var(--color-accent-border);
  border-radius: var(--radius-pill);
  background: var(--color-accent-muted);
  color: var(--color-text);
  font-size: var(--text-xs);
}

.chipText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reached {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--color-success);
  white-space: nowrap;
}

.page {
  box-sizing: border-box;
  max-width: 820px;
  height: 100%;
  margin: 0 auto;
  padding: var(--space-6) var(--space-4);
  overflow: auto;
  background: var(--color-bg);
  color: var(--color-text);
  font-size: var(--text-md);
  line-height: var(--leading-normal);
}

.muted {
  color: var(--color-text-muted);
}

.tasks {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding-left: var(--space-5);
}

.tasks h2 {
  margin: 0 0 var(--space-2);
  font-size: var(--text-lg);
}

.tasks dt {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  font-weight: var(--weight-semibold);
}

.tasks dd {
  margin: 0 0 var(--space-2);
}

.log {
  margin-top: var(--space-6);
  padding: var(--space-4);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface-1);
}

.actions {
  display: flex;
  gap: var(--space-2);
}
